<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
    lock-scroll
    append-to-body
  >
    <div class="content">
      <div class="transfer-wrapper" :class="{'mark':isSelectedAll}" @submit.prevent>
        <!-- 左侧 -->
        <div class="transfer__left">
          <div class="transfer-header__wrapper">
            <div class="filter-wrapper">
              <el-input
                v-model="filter.platformName"
                placeholder="请输入运营商名称"
                class="filter-keyword__input"
              ></el-input>
              <el-button @click="$_search" class="search__btn">查询</el-button>
              <el-button @click="$_reset" class="reset__btn">重置</el-button>
            </div>
          </div>

          <div class="opera-box" v-if="showAllSelect">
            <el-checkbox v-model="isSelectedAll" label="全选运营商" name="all"></el-checkbox>
          </div>

          <!-- 数据列表 -->
          <el-table
            class="table-list__box"
            ref="standbyList"
            :data="dataList"
            v-loading="isLoading"
            :height="showAllSelect ? 420 : 460"
            @select="$_selectRow"
            @select-all="$_selectAll"
            stripe
            tooltip-effect="dark"
          >
            <el-table-column type="selection" width="50"></el-table-column>

            <el-table-column
              v-for="column in columns"
              :key="column.key"
              :prop="column.key"
              :label="column.label"
              :width="column.width"
              :resizable="false"
              show-overflow-tooltip
            ></el-table-column>

            <div class="table-list__empty small" slot="empty"></div>
          </el-table>

          <div class="pagination__wrapper">
            <cd-pagination
              ref="pager"
              :total="pagination.total"
              :currPage="pagination.pageNow"
              :pageSize="pagination.pageSize"
              @changepage="$_changeCurrent"
              @changesize="$_changeSize"
              :explainShow="false"
              @refresh="$_getDataList"
            ></cd-pagination>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="transfer__right">
          <div class="transfer-header__wrapper">
            <h3>已选运营商</h3>
            <el-button @click="$_clearSelecteds" class="clear__btn clear-all__btn">清除已选项</el-button>
          </div>

          <!-- 已选列表 -->
          <div class="table-list__wrapper">
            <el-table
              class="table-list__box selected-list"
              ref="selectedList"
              :data="selectedList"
              :height="505"
              stripe
              @selection-change="$_selectedChange"
              tooltip-effect="dark"
            >
              <el-table-column type="selection" align="center" width="50"></el-table-column>

              <el-table-column
                v-for="column in columns"
                :key="column.key"
                :prop="column.key"
                :label="column.label"
                :width="column.width"
                :resizable="false"
                show-overflow-tooltip
              ></el-table-column>

              <span class="table__empty-text" slot="empty">←请在左边栏目中选择运营商</span>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">{{submitTxt}}</el-button>
      <el-button class="cancel__btn" @click="$_cancle">{{cancleTxt}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import handlePagination from "@/mixins/handlePagination";
const columns = [
  { key: "platformName", label: "运营商名称" },
  // { key: "systemCode", label: "系统编码" },
];

export default {
  name: "modal-select-platforms",
  mixins: [handlePagination],
  props: {
    orgType: { type: Number, default: -1 },
    title: { type: String, default: "" },
    isRequire: { type: Boolean, default: true },
    showAllSelect: { type: Boolean, default: false },
    selecteds: { type: Array, default: [] },
    submitTxt: { type: String, default: "保存" },
    cancleTxt: { type: String, default: "取消" },
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      isSelectedAll: false,
      filter: {
        storeName: "",
        storeId: "",
      },
      columns,
      dataList: [],
      standBySelecteds: [], // 左侧可选择数据 已选择项
      selectedList: [], // 已选择项
      selectTheSelected: [], // 选择已选项
    };
  },
  methods: {
    // 搜索按钮
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getDataList();
    },
    // 重置按钮
    $_reset() {
      this.filter.platformName = "";
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getDataList();
    },
    // 查询列表数据
    $_getDataList() {
      if (this.isLoading) return false;
      this.isLoading = true;
      let { platformName } = this.filter;
      let { pageNow, pageSize } = this.pagination;
      const postData = {
        platformName,
        status: 1,
        orgType: this.orgType,
        pageNow,
        pageSize,
      };
      this.$service.post("getPlatformList", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          let { pages, total, rows } = result.data;
          this.pagination.pages = pages;
          this.pagination.total = total;
          let dataList = rows.map((item) => {
            let { platformKey, platformName, orgType } = item;
            let orgName = orgType === 1 ? "自定义组织" : "默认组织";
            return {
              platformKey,
              platformName,
              orgName,
              orgType,
            };
          });
          this.dataList = dataList.concat([]);
          setTimeout(() => {
            let selectedKey = this.selectedList.reduce(
              (prev, next) => prev.concat([next.platformKey]),
              []
            );

            let rows = this.dataList.filter(
              (item) => ~selectedKey.indexOf(item.platformKey)
            );
            rows.length > 0 && this.toggleSelection(rows);
            this.standBySelecteds = rows.concat([]);
          }, 50);
        }
        this.isLoading = false;
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.standbyList &&
            this.$refs.standbyList.toggleRowSelection(row);
        });
      } else {
        this.$refs.standbyList && this.$refs.standbyList.clearSelection();
      }
    },
    // 单选行
    $_selectRow(selection, row) {
      this.standBySelecteds = selection.concat();
      if (selection.some((item) => item.platformKey === row.platformKey)) {
        // 选中
        let index = this.selectedList.findIndex(
          (item) => item.platformKey === row.platformKey
        );
        if (!~index) {
          this.selectedList.push(row);
        }
      } else {
        // 取消勾选
        let index = this.selectedList.findIndex(
          (item) => item.platformKey === row.platformKey
        );
        if (~index) {
          this.selectedList.splice(index, 1);
        }
      }
    },
    // 全选
    $_selectAll(selection) {
      this.standBySelecteds = selection.concat();
      if (selection.length > 0) {
        // 全选
        selection.forEach((row) => {
          let index = this.selectedList.findIndex(
            (item) => item.platformKey === row.platformKey
          );
          if (!~index) {
            this.selectedList.push(row);
          }
        });
      } else {
        // 取消全选
        this.dataList.forEach((row) => {
          let index = this.selectedList.findIndex(
            (item) => item.platformKey === row.platformKey
          );
          if (~index) {
            this.selectedList.splice(index, 1);
          }
        });
      }
    },
    // 右侧列表部分,
    $_selectedChange(selection) {
      this.selectTheSelected = selection.splice(0);
    },
    // 清除已选项
    $_clearSelecteds() {
      const self = this;
      self.selectTheSelected.forEach((item) => {
        // 右侧数组删除已选项
        let index = self.selectedList.findIndex(
          (row) => row.platformKey === item.platformKey
        );
        if (~index) {
          self.selectedList.splice(index, 1);
        }
        // 判断左侧数据是否已勾选, 已勾选则取消
        let row = self.standBySelecteds.find(
          (row) => row.platformKey === item.platformKey
        );
        if (typeof row !== "undefined") {
          self.$refs.standbyList.toggleRowSelection(row);
        }
      });
      self.selectTheSelected.splice(0);
    },

    // 保存
    $_submit() {
      if (this.isSelectedAll) {
        this.$emit("callback", [
          {
            platformKey: "all",
            platformName: "全选运营商",
          },
        ]);
        return true;
      }
      if (this.isRequire) {
        if (this.selectedList.length) {
          let platforms = this.selectedList.concat([]);
          this.$emit("callback", platforms);
          this.$_cancle();
        } else {
          $MessageBox.alert({ content: "请至少选择一个运营商!" });
        }
      } else {
        this.$emit("callback", []);
        this.$_cancle();
      }
    },
    // 取消
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
  },
  created() {
    if (this.selecteds.length > 0) {
      if (this.selecteds[0].platformKey === "all") {
        this.isSelectedAll = true;
      } else {
        this.selectedList = this.selecteds.concat([]);
      }
    }
    this.$_getDataList();
  },
  mounted() {
    this.visible = true;
  },
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  padding: 20px 30px;
  overflow: hidden;
}
.transfer-wrapper {
  position: relative;
  &.mark {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba($color: #fff, $alpha: 0.4);
      z-index: 111;
      cursor: not-allowed;
    }
  }
  &::after {
    content: "";
    display: table;
    clear: both;
  }
  .transfer__left,
  .transfer__right {
    width: 456px;
    height: 545px;
    border: 1px solid #eee;
  }
  .transfer__left {
    float: left;
  }
  .transfer__right {
    float: right;
  }
  .transfer-header__wrapper {
    position: relative;
    height: 40px;
    border-bottom: 1px solid #eee;
    background-color: #f5f6f7;
    padding-left: 8px;
    h3 {
      padding-left: 4px;
      line-height: 40px;
      font-size: 12px;
      color: #535353;
    }
    .filter-wrapper,
    .clear-all__btn {
      position: absolute;
    }
    .filter-wrapper {
      top: 5px;
      .autocomplete-box {
        display: inline-block;
        position: relative;

        .autocomplete-empty {
          padding: 10px;
          margin: 0;
          color: #535353;
          top: 33px;
          width: 100%;
        }
      }
    }
    .filter-keyword__input {
      width: 110px;
      margin-right: 10px;
    }
    .clear-all__btn {
      top: 7px;
      right: 20px;
    }
  }
}

.table-list__box {
  border: 1px solid #eee;
  margin-top: -1px;
  background-color: #f9f9f9;
}
.opera-box {
  padding: 10px 20px;
  position: relative;
  z-index: 112;
}
</style>
